import React from 'react';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import StatusCheckbox from '../StatusCheckbox/StatusCheckbox';
import { getStatusClass, CHECKBOX_STATUSES } from '../../../constants/orderStatuses';
import { getLateOrderDescription } from '../../../utils/orderUtils';
import './OrderCard.css';

const OrderCard = ({ 
  order, 
  onCardClick, 
  onStatusChange,
  isDragging = false,
  isOver = false 
}) => {
  const handleCardClick = (e) => {
    // Don't trigger card click if clicking on checkboxes or links
    if (e.target.closest('.pedido-checkboxes') || e.target.closest('a')) {
      return;
    }
    onCardClick(order);
  };

  const isSeparacaoConcluido = order.statusSeparacao === CHECKBOX_STATUSES.CONCLUIDO;
  const isProducaoConcluido = order.statusProducao === CHECKBOX_STATUSES.CONCLUIDO;
  const lateDescription = getLateOrderDescription(order);

  return (
    <div 
      className={`order-card ${getStatusClass(order.statusOperacao)} ${isDragging ? 'dragging' : ''} ${isOver ? 'drag-over' : ''} ${order.atrasado ? 'late' : ''}`}
      data-order-id={order.idPed}
      data-status={order.statusOperacao}
      data-late={order.atrasado}
      data-position={order.tokenPrioridade}
      draggable={true}
      onClick={handleCardClick}
    >
      <div className="order-header">
        <div className="order-id">
          <a 
            href={`https://app.vhsys.com.br/index.php?Secao=Vendas.Pedidos&Modulo=Vendas#!editar/${order.idPed}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            <strong>#{order.idPedido}</strong>
          </a>
          {order.atrasado && (
            <span className="late-indicator" title={lateDescription}>
              ⚠️ {lateDescription}
            </span>
          )}
        </div>
        <div className="order-date">
          Empresa {order.tenantId} | {new Date(order.dataPedido).toLocaleDateString('pt-BR')}
        </div>
      </div>

      <div className="order-client">
        <div className="client-name">{order.fantasiaCliente}</div>
        <div className="client-location">
          {order.bairroCliente}, {order.cidadeCliente} - {order.ufCliente}
        </div>
      </div>

      {order.referenciaPedido && (
        <div className="order-ref">
          <strong>Ref:</strong> {order.referenciaPedido}
        </div>
      )}

      <div className="order-items">
        <span className="items-count">{order.itens.length} itens</span>
      </div>

      <div className="order-checkboxes">
        <StatusCheckbox
          orderId={order.idPed}
          tenantId={order.tenantId}
          statusType="separacao"
          isChecked={isSeparacaoConcluido}
          onStatusChange={onStatusChange}
        />
        <StatusCheckbox
          orderId={order.idPed}
          tenantId={order.tenantId}
          statusType="producao"
          isChecked={isProducaoConcluido}
          onStatusChange={onStatusChange}
        />
      </div>

      {order.obsPedido && (
        <div className="order-obs">
          <strong>Obs:</strong> {order.obsPedido}
        </div>
      )}

      {order.observacaoCliente && (
        <div className="order-obs-cliente">
          <strong>Obs Cliente:</strong> {order.observacaoCliente}
        </div>
      )}

      {/* Card loading overlay */}
      <div className="card-loading-overlay" style={{ display: 'none' }}>
        <div className="loading-spinner card-loading">
          <LoadingSpinner text="Atualizando..." />
        </div>
      </div>
    </div>
  );
};

export default OrderCard;
